export default __webpack_public_path__ + "static/media/ibusiness.3eb18903.png";